import Hero from './hero-events'

export default Hero
